import { Stack } from 'expo-router';

/**
 * Meals tab stack: the dashboard (`index`) and the per-day log flow
 * (`(detail)` group, which carries its own header + full-height chrome).
 * Living inside the `(tabs)` navigator keeps the bottom tab bar visible on the
 * log screen.
 */
export default function MealsLayout() {
  return (
    <Stack screenOptions={{ headerShown: false }}>
      <Stack.Screen name="index" />
      <Stack.Screen name="(detail)" />
    </Stack>
  );
}
